import { render, staticRenderFns } from "./sticky-feedback.vue?vue&type=template&id=4e9f2cd4&"
import script from "./sticky-feedback.vue?vue&type=script&lang=js&"
export * from "./sticky-feedback.vue?vue&type=script&lang=js&"
import style0 from "./sticky-feedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9f2cd4')) {
      api.createRecord('4e9f2cd4', component.options)
    } else {
      api.reload('4e9f2cd4', component.options)
    }
    module.hot.accept("./sticky-feedback.vue?vue&type=template&id=4e9f2cd4&", function () {
      api.rerender('4e9f2cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/sticky-feedback.vue"
export default component.exports